import { Api } from "./Api";

const API_URL = (process.env.REACT_APP_API_URL ?? Api).replace(/\/+$/, "");

export async function listPhotos(recordId) {
  const res = await fetch(`${API_URL}/BibliotecaFoto/${recordId}`);
  if (!res.ok) throw new Error("Error al obtener las fotos");
  return await res.json();
}

export async function uploadPhotos(recordId, files) {
  const form = new FormData();
  form.append("recordId", recordId);
  for (const file of files) {
    form.append("files", file);
  }

  const res = await fetch(`${API_URL}/BibliotecaFoto/upload`, {
    method: "POST",
    body: form,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Error al subir archivos");
  }
  return await res.json();
}

export async function setCover(photoId) {
  const res = await fetch(`${API_URL}/BibliotecaFoto/${photoId}/cover`, {
    method: "POST",
  });

  if (!res.ok) throw new Error("Error al marcar como portada");
  return await res.json();
}

export async function removePhoto(photoId) {
  const res = await fetch(`${API_URL}/BibliotecaFoto/${photoId}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar la foto");
  return true;
}
